<template>
    <span>
      <b-tooltip label="Sync to iRebal"
        position="is-bottom"
      >
        <b-button
          label="iRebal"
          type="is-primary"
          size="is-small"
          icon-pack="fas"
          icon-left="cloud-upload-alt"
          v-bind:loading="in_progress_one"
          @click="syncPortfolio"
          outlined
        />
    </b-tooltip>

</span>
</template>

<script>
import IRebalMixin from '@frontend/dash3/js/components/integrations/irebal/IRebalMixin.js';

export default {
  mixins: [IRebalMixin],
}
</script>